/*
 * Copyright (c) Worldline 2023.
 */

export const AgreementsOptions = {
    otpPattern: /^\d{6}$/,
    authorizedWebConsentsTypes: ['WEB_CONSENT', 'SMARTPHONE_CONSENT']
}
